import React from "react";
import { Link } from "react-router-dom";

class Popout extends React.Component {

    render() {
        return (
            <div className="popout">
                <div className="wrapper">
                    <header>
                        <div className="logo-wrapper">
                            <Link to="/" className="inner" onClick={this.props.togglePopout}>
                                <img src={`${process.env.PUBLIC_URL}/images/logo-dark.png`} className="logo" alt="" />
                                <img src={`${process.env.PUBLIC_URL}/images/logo-text-1-dark.png`} alt="" />
                                <img src={`${process.env.PUBLIC_URL}/images/logo-text-2-dark.png`} alt="" />
                            </Link>
                        </div>
                        <img className="close-icon" onClick={this.props.togglePopout} src={`${process.env.PUBLIC_URL}/images/close-icon.png`} alt=""/>
                    </header>
                    <div className="content">
                        <h2>About the Authors</h2>
                        <p><strong>Meryl Carmel</strong> is an author and historian. Ms. Carmel has a particular interest in local New Jersey history. Her book <strong><em>Finding Kate: The Unlikely Journey of 20th Century Healthcare Advocate Kate Macy Ladd</em></strong> was published in 2018.</p>
                        <p><strong>Jim Stadtmueller</strong> is a Senior Managing Director at Peapack-Gladstone Bank. A career commercial lender, Mr. Stadtmueller joined the Bank in 1992. He is a native of The Somerset Hills and the Bank’s unofficial historian.</p>
                        <h3>Acknowledgments:</h3>
                        <p>The authors thank <strong>W. Barry Thomson</strong> for his research assistance.</p>
                        <p>The authors thank <strong>Lynda Stadtmueller</strong> and <strong>Vivian Fransen</strong> for their constructive comments and proofreading expertise.</p>
                        <p>The authors thank <strong>John Charles Smith</strong> for use of his map “Bedminster Township and Borough of Peapack-Gladstone 1873-1939” as endsheets.</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Popout;